import { useEffect } from "react";
import Inventory from '../table/Tableinventory';



const Dashboard = () => {
  useEffect(() => {
    // getPromise(["sales", "purchases"]);
  }, []);


  return (
    <>
    
    <Inventory/>
    
     
     </>
  );
};

export default Dashboard;
